import { makeAutoObservable, autorun } from 'mobx';

class Profile {
  isTeacher = false;

  role = 0;

  access = 0;

  data = {};

  token = null;

  avatar = '/assets/images/avatars/avatar_default.jpg';

  constructor() {
    makeAutoObservable(this);

    const storedJson = localStorage.getItem('LalaStore');
    if (storedJson) Object.assign(this, JSON.parse(storedJson));
    autorun(() => {
      localStorage.setItem('LalaStore', JSON.stringify(this));
    });
  }

  setTeacherRole() {
    this.isTeacher = true;
    this.role = 2;
  }

  setStudentRole() {
    this.isTeacher = false;
    this.role = 1;
  }

  setAvatar(img) {
    this.avatar = img;
  }

  setSelfstudyAccess() {
    this.access = 1;
  }

  setFullAccess() {
    this.access = 2;
  }

  login(data) {
    this.data = data;
    this.token = data.access_token; // Зберігаємо токен

    // set access flags automatically from server response when possible
    // If the student has course_id and sgroup_id -> full access
    if (data && data.course_id != null && data.sgroup_id != null) {
      this.setFullAccess();
    } else if (data && data.selfstudy === 1) {
      // If backend indicates selfstudy access, set selfstudy access
      this.setSelfstudyAccess();
    } else {
      // default: no extra access
      this.access = 0;
    }
  }

  logout() {
    localStorage.removeItem('LalaStore');
    this.isTeacher = false;
    this.data = {};
    this.role = 0;
    this.token = null; // Очищаємо токен
  }
}

export default new Profile();
